export const AWS_CREDENTIALS_DOC_LINK = 'https://docs.aws.amazon.com/general/latest/gr/aws-sec-cred-types.html';
export const K8S_INVENTORY_URL = '/dbaas/kubernetes';
export const DBAAS_INVENTORY_URL = '/dbaas';
